module.exports = __webpack_public_path__ + "student-8bb3c775071248eb11f4.png";